import { GINOMessage } from "../../../../Chat/types";

import { ChatMessage } from "../../../api/services/chat";
import { extractJsonFromText } from "../../../utils/openAI";

import ListMessage from "./ListMessage";
import FormattedText from "./FormattedText";

const AIMessage = ({ message }: { message: ChatMessage }) => {
  const messageContent = message.text;

  const json = extractJsonFromText(messageContent);

  const MessageType = !!json ? "list" : "text";
  if (MessageType === "text") return <FormattedText content={messageContent} />;
  if (MessageType === "list") return <ListMessage json={json} />;
  return null;
};

export default AIMessage;
